export const STORAGE_WARNING_USAGE_PERCENTAGE = 80;
export const STORAGE_CRITICAL_USAGE_PERCENTAGE = 90;

export function getStorageUsageStatus(storageUsage) {
    const rawPercentage = Number(storageUsage?.usagePercentage);
    const usagePercentage = Number.isFinite(rawPercentage)
        ? Math.max(0, Math.min(100, rawPercentage))
        : 0;

    if (storageUsage?.unlimited) {
        return {
            level: "normal",
            usagePercentage,
            color: "var(--green-500)",
            textClassName: "text-green-500",
            messageSeverity: null,
            messageKey: null,
        };
    }

    if (usagePercentage >= STORAGE_CRITICAL_USAGE_PERCENTAGE) {
        return {
            level: "critical",
            usagePercentage,
            color: "var(--red-500)",
            textClassName: "text-red-500",
            messageSeverity: "error",
            messageKey: "commerce.storage.critical-warning",
        };
    }

    if (usagePercentage >= STORAGE_WARNING_USAGE_PERCENTAGE) {
        return {
            level: "warning",
            usagePercentage,
            color: "var(--orange-500)",
            textClassName: "text-orange-500",
            messageSeverity: "warn",
            messageKey: "commerce.storage.capacity-warning",
        };
    }

    return {
        level: "normal",
        usagePercentage,
        color: "var(--green-500)",
        textClassName: "text-green-500",
        messageSeverity: null,
        messageKey: null,
    };
}
